import { createBrowserHistory } from 'history';

const history = createBrowserHistory(); // Needs be history v<5
export default history;
